import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Image, Nav, Row, Form, Dropdown, Accordion } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import "../../../../Assets/css/MegaMenu.css";
import Login from "../../../../Components/Login";
import { useHistory, useLocation } from "react-router-dom";
import { Drawer } from "@mui/material";
import MeueIcon from "../Assets/img/menu_icon.svg"
import { Email_details, client_name, contact_number } from "../../../../Helpers/request";
import { isDesktop, isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { AiOutlineClose } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { BsFillChatFill, BsFillTelephoneFill } from "react-icons/bs";
import { IoMdMail, IoMdContact } from "react-icons/io";
import { img_url } from "../../../../Helpers/request";
import HeaderStyle from "../Assets/megamenu.module.css";
import { setHeaderHeight, currencyCode, currencyFlag, currencyIcon, loginDrawer } from "../../../../Reducer/homeReducer";

const MegaMenu = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [setDesktopSearch, setShowDesktopSearch] = useState(false);
  const [submenu, setSubmenu] = useState([]);
  const [show, setShow] = useState(false);
  const [topHeader, setTopHeader] = useState(true);
  const [left, setLeft] = useState(false);
  const [hover, setHover] = useState(0);
  const [search_text, setSearch_text] = useState("");
  const menudata = useSelector((state) => state.persistedReducer.home.menu);
  // const currencycode = useSelector((state) => state.persistedReducer.home.currencycode);
  // const currencyflag = useSelector((state) => state.persistedReducer.home.currencyflag);
  // const currencydata = useSelector((state) => state.persistedReducer.home.currency);


  const user = useSelector(
    (state) => state.persistedReducer.home.userData
  );
  useEffect(() => {
    document.body.className = window.location.pathname;
    return () => {
      document.body.className = "";
    };
  }, [window.location.pathname]);

  const [
    isScrollValueMoreThanHeaderHeight,
    setIsScrollValueMoreThanHeaderHeight,
  ] = useState(false);

  const cartlength = useSelector(
    (state) => state.persistedReducer.cart.cartlength
  );
  const wishlistlength = useSelector(
    (state) => state.persistedReducer.wish.whishlistlength
  );
  const toggleDrawer = (open) => {
    setLeft(open);
  };


  useEffect(() => {
    // googleTranslateElementInit()
    const handleScroll = () => {
      // console.log(window.scrollY);
      setIsScrollValueMoreThanHeaderHeight(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const googleTranslateElementInit = () => {
  //   new window.google.translate.TranslateElement(
  //     {
  //       pageLanguage: "en",
  //       includedLanguages: "en,es,fr,de,iw,ja,zh-CN,sv,tr,ar,hi",
  //       gaTrack: true,
  //     },
  //     "google_translate_element"
  //   );
  // };

  // const currencyHandle = async (code, img, icon) => {
  //   await dispatch(currencyIcon(icon));
  //   await dispatch(currencyCode(code));
  //   await dispatch(currencyFlag(img));
  //   localStorage.removeItem("bw-fancycolordata");
  //   localStorage.removeItem("bw-gemstonedata");
  //   localStorage.removeItem("bw-diamonddata");
  //   localStorage.removeItem("bw-settingdata");
  //   sessionStorage.removeItem("bw-listfilter");
  //   sessionStorage.removeItem("bw_f_filter");
  //   sessionStorage.removeItem("bw_s_filter");
  //   sessionStorage.removeItem("bw_d_filter");
  //   sessionStorage.removeItem("bw_g_filter");
  //   sessionStorage.removeItem("bw-list-category");
  //   if (window.location.pathname == "/complete-diamond-ring") {
  //     history.push("/diamonds");
  //   } else if (window.location.pathname == "/complete-gemstone-ring") {
  //     history.push("/gemstones");
  //   } else if (window.location.pathname == "/complete-fancycolor-ring") {
  //     history.push("/fancy-color-diamond");
  //   }
  //   window.location.reload();
  // };

  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const resizeScreen = () => {
    setScreenWidth(window.innerWidth);
  };
  useEffect(() => {
    resizeScreen();
    window.addEventListener("resize", resizeScreen);
    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  });

  const divRef = useRef(null);
  const [divHeight, setDivHeight] = useState(0);

  useEffect(() => {
    if (menudata.length > 0 && divRef.current) {
      setDivHeight(divRef.current.offsetHeight);
      let height = divRef.current.offsetHeight
      dispatch(setHeaderHeight(height));
    }
  }, [menudata]);


  // useEffect(() => { 
  //   if (location.pathname.startsWith('/search/')) { 
  //     setSearch_text(''); 
  //   } else { 
  //     setSearch_text('');
  //     setShowDesktopSearch(false);
  //   }
  // }, []);

  return (
    <>
      <div className="rcs_header_seaction" id="rcs_header_seaction">
        {/* Top Header Section */}
        {topHeader ?
          isDesktop ?
            <div className={"rcs_top_header " + HeaderStyle.Showcase_top_header}>

              <Container
                className={
                  "rcs_custom_home_container " +
                  HeaderStyle.Showcase_custom_home_container
                }
              >
                <div
                  className={
                    "rcs_top_head_content " +
                    HeaderStyle.Showcase_top_head_content
                  }
                >
                  <Row>
                    <Col md={12} className="p-0 text-center">
                      <p className={HeaderStyle.Showcase_top_head_text}>
                        Free Shipping All Over The World
                      </p>
                    </Col>
                    <Col xs={12} md={3} lg={4} className="p-0">
                      <div
                        id="google_translate_element"
                        className="float-right"
                      ></div>
                    </Col>
                  </Row>
                </div>
              </Container>
            </div>
            : '' : ("")}

        {/* Top Header Section */}
        <div
          style={{ height: divHeight }
            // screenWidth > 1439
            //   ? { height: "130px" }
            //   : screenWidth > 1279
            //   ? { height: "120px" }
            //   : screenWidth > 1023
            //   ? { height: "110px" }
            //   : screenWidth < 768
            //   ? { height: "52px" }
            //   : { height: "100%" }
          }
        >
          <div ref={divRef}
            className={
              isScrollValueMoreThanHeaderHeight
                ? "rcs_logo_head rcs_sticky-top sticky-top"
                : "rcs_logo_head"
            }
          >
            {/* Header Section */}
            {isMobile ?
              <>
                <div className={"rcs_top_header " + HeaderStyle.Showcase_top_header}>
                  <Container
                    className={
                      "rcs_custom_home_container " +
                      HeaderStyle.Showcase_custom_home_container
                    }
                  >
                    <div
                      className={
                        "rcs_top_head_content " +
                        HeaderStyle.Showcase_top_head_content
                      }
                    >
                      <p className={HeaderStyle.Showcase_top_head_text}>
                        Free Shipping All Over The World
                      </p>
                    </div>
                  </Container>


                </div>
              </> : ''}
            <div className="rcs_header">
              <Container fluid className="p-0">
                {/* Center Header */}
                <div className={HeaderStyle.showcase_center_header}>
                  <Row>
                    {isMobile ? (
                      <Col xs={2} md={3} className="my-auto">
                        <Nav className="m-auto rcs_mobile_header_menu">
                          <Image
                            onClick={() => {
                              toggleDrawer(true);
                              dispatch(loginDrawer(false));
                            }}
                            src={MeueIcon}
                            alt="menu icon"
                            width="30px"
                          ></Image>
                        </Nav>
                      </Col>
                    ) : (
                      <Col md={3} className="d-flex align-items-center">
                        <div
                          className={HeaderStyle.showcase_center_header_left}
                        >
                          <div
                            className={
                              setDesktopSearch == true
                                ? "show " +
                                " rcs_search_bar " +
                                HeaderStyle.DesktopSearch
                                : "close " +
                                " rcs_search_bar " +
                                HeaderStyle.DesktopSearch
                            }
                          >
                            {setDesktopSearch == true && (
                              <Form
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  history.push("/search/" + search_text);
                                  window.scrollTo(0, 0);
                                  //setSearch_text("");

                                }}
                              >
                                <Form.Control
                                  type="text"
                                  placeholder="Search for.."
                                  value={search_text}
                                  onChange={(e) =>
                                    setSearch_text(e.target.value)
                                  }
                                />
                                <AiOutlineClose
                                  className={
                                    HeaderStyle.DesktopSearchClose
                                  }
                                  onClick={() => {
                                    setShowDesktopSearch(false);
                                    setSearch_text('');
                                  }}
                                />
                              </Form>
                            )}
                          </div>
                          <svg className="cursor-pointer" onClick={() =>
                            setShowDesktopSearch(!setDesktopSearch)
                          } width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M18.0186 18.4851L21.5426 22" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>

                        </div>
                      </Col>
                    )}
                    <Col
                      xs={8}
                      md={6}
                      className="d-flex align-items-center justify-content-center "
                    >
                      <div
                        className={
                          "mg_menu_logo_main_div " +
                          HeaderStyle.showcase_center_header_center
                        }
                      >
                        <div className="rcs_logo_section text-center">
                          <NavLink to="/"  onClick={()=>{setSearch_text('')}}>
                            {/* <Image
                            height="60"
                            onClick={() => history.push("/")}
                            src={logoImage}
                            alt={client_name.c_name}
                          ></Image> */}
                            Montgomery Jewelers
                          </NavLink>
                        </div>
                      </div>
                    </Col>

                    {isMobile ? (
                      <Col xs={2} md={3} className="my-auto">
                        <div className="rcs_right_side rcs_right_side_mobile1">
                          <ul>
                            <li>
                              <Login />
                            </li>
                            <li className="d-none d-sm-block">
                              <div
                                className="showacase_mobile_login  position-relative"
                                onClick={() => toggleDrawer(false)}
                              >
                                <div
                                  className="d-flex justify-content-start align-items-center"
                                  onClick={() =>
                                    user?.isLogin
                                      ? history.push("/account/wishlist")
                                      : history.push("/wishlist")
                                  }
                                >
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.87187 11.5983C1.79887 8.24832 3.05287 4.41932 6.56987 3.28632C8.41987 2.68932 10.4619 3.04132 11.9999 4.19832C13.4549 3.07332 15.5719 2.69332 17.4199 3.28632C20.9369 4.41932 22.1989 8.24832 21.1269 11.5983C19.4569 16.9083 11.9999 20.9983 11.9999 20.9983C11.9999 20.9983 4.59787 16.9703 2.87187 11.5983Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16 6.69995C17.07 7.04595 17.826 8.00095 17.917 9.12195" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>

                                  {wishlistlength && wishlistlength != "0" ? (
                                    <span className="rcs_wish_badge new-mob-wish">
                                      {wishlistlength}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </li>
                            <li
                              className=""
                              onClick={() => {
                                history.push("/cart");
                              }}
                            >
                              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5134 21.5H8.16555C5.09919 21.5 2.74679 20.3925 3.41498 15.9348L4.19301 9.89363C4.60491 7.66937 6.02367 6.81812 7.26852 6.81812H17.447C18.7102 6.81812 20.0466 7.73345 20.5225 9.89363L21.3006 15.9348C21.8681 19.8891 19.5797 21.5 16.5134 21.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.6502 6.59848C16.6502 4.21241 14.716 2.27812 12.3299 2.27812V2.27812C11.1809 2.27325 10.0773 2.72628 9.26308 3.53703C8.44889 4.34778 7.9912 5.44947 7.99121 6.59848H7.99121" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15.296 11.102H15.2502" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.46492 11.102H9.41916" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                              </svg>

                              {/* <MdOutlineShoppingBag className="rcs_cart_mobile_icon" /> */}
                              {cartlength && cartlength != "0" ? (
                                <span className="rcs_cart_badge">
                                  {cartlength}
                                </span>
                              ) : (
                                ""
                              )}
                            </li>
                          </ul>
                        </div>
                      </Col>
                    ) : isTablet ? (
                      <Col>
                        <div className="rcs_right_side rcs_right_side_mobile1">
                          <ul>
                            <li>
                              <Login />
                            </li>
                            <li
                              onClick={() => {
                                history.push("/cart");
                              }}
                            >
                              <svg
                                className="rcs_cart_mobile_icon"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M14.1213 11.2331H16.8891C17.3088 11.2331 17.6386 10.8861 17.6386 10.4677C17.6386 10.0391 17.3088 9.70236 16.8891 9.70236H14.1213C13.7016 9.70236 13.3719 10.0391 13.3719 10.4677C13.3719 10.8861 13.7016 11.2331 14.1213 11.2331ZM20.1766 5.92749C20.7861 5.92749 21.1858 6.1418 21.5855 6.61123C21.9852 7.08067 22.0551 7.7542 21.9652 8.36549L21.0159 15.06C20.8361 16.3469 19.7569 17.2949 18.4879 17.2949H7.58639C6.25742 17.2949 5.15828 16.255 5.04837 14.908L4.12908 3.7834L2.62026 3.51807C2.22057 3.44664 1.94079 3.04864 2.01073 2.64043C2.08068 2.22305 2.47038 1.94649 2.88006 2.00874L5.2632 2.3751C5.60293 2.43735 5.85274 2.72207 5.88272 3.06905L6.07257 5.35499C6.10254 5.68257 6.36234 5.92749 6.68209 5.92749H20.1766ZM7.42604 18.9079C6.5867 18.9079 5.90723 19.6018 5.90723 20.459C5.90723 21.306 6.5867 22 7.42604 22C8.2554 22 8.93487 21.306 8.93487 20.459C8.93487 19.6018 8.2554 18.9079 7.42604 18.9079ZM18.6673 18.9079C17.8279 18.9079 17.1484 19.6018 17.1484 20.459C17.1484 21.306 17.8279 22 18.6673 22C19.4966 22 20.1761 21.306 20.1761 20.459C20.1761 19.6018 19.4966 18.9079 18.6673 18.9079Z"
                                  fill="var(--primary)"
                                />
                              </svg>
                              {/* <MdOutlineShoppingBag className="rcs_cart_mobile_icon" /> */}
                              {cartlength && cartlength != "0" ? (
                                <span className="rcs_cart_badge">
                                  {cartlength}
                                </span>
                              ) : (
                                ""
                              )}
                            </li>
                          </ul>
                        </div>
                      </Col>
                    ) : (
                      <Col
                        md={3}
                        className="d-flex align-items-center justify-content-end"
                      >
                        <div
                          className={
                            "mg_menu_right_side_area " +
                            HeaderStyle.showcase_center_header_right
                          }
                        >
                          <div className="rcs_right_side rcs_right_side_mobile d-none d-lg-block">
                            <ul>

                              <li className="d-none d-lg-block">
                                <Login />
                              </li>
                              <li
                                className="d-none d-lg-block"
                                onClick={() =>
                                  user?.isLogin
                                    ? history.push("/account/wishlist")
                                    : history.push("/wishlist")
                                }
                              >


                                <svg className="rcs_wishlist_icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.87187 11.5983C1.79887 8.24832 3.05287 4.41932 6.56987 3.28632C8.41987 2.68932 10.4619 3.04132 11.9999 4.19832C13.4549 3.07332 15.5719 2.69332 17.4199 3.28632C20.9369 4.41932 22.1989 8.24832 21.1269 11.5983C19.4569 16.9083 11.9999 20.9983 11.9999 20.9983C11.9999 20.9983 4.59787 16.9703 2.87187 11.5983Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M16 6.69995C17.07 7.04595 17.826 8.00095 17.917 9.12195" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                                {/* <img
                                onMouseOver={() => setWishover(true)}
                                onMouseLeave={() => setWishover(false)}
                                className="rcs_wishlist_icon"
                                src={wishover ? Heart2 : Heart1}
                              /> */}
                                {wishlistlength && wishlistlength !== "0" ? (
                                  <span className="rcs_wish_badge">
                                    {wishlistlength}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </li>
                              <li
                                className="d-none d-lg-block"
                                onClick={() => {
                                  history.push("/cart");
                                }}
                              >
                                {/* <img
                              onMouseOver={() => setCarthover(true)}
                              onMouseLeave={() => setCarthover(false)}
                              className="rcs_wishlist_icon"
                              src={carthover ? Cart2 : Cart1}
                            /> */}

                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5134 21.5H8.16555C5.09919 21.5 2.74679 20.3925 3.41498 15.9348L4.19301 9.89363C4.60491 7.66937 6.02367 6.81812 7.26852 6.81812H17.447C18.7102 6.81812 20.0466 7.73345 20.5225 9.89363L21.3006 15.9348C21.8681 19.8891 19.5797 21.5 16.5134 21.5Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M16.6502 6.59848C16.6502 4.21241 14.716 2.27812 12.3299 2.27812V2.27812C11.1809 2.27325 10.0773 2.72628 9.26308 3.53703C8.44889 4.34778 7.9912 5.44947 7.99121 6.59848H7.99121" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M15.296 11.102H15.2502" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M9.46492 11.102H9.41916" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                                {cartlength && cartlength != "0" ? (
                                  <span className="rcs_cart_badge">
                                    {cartlength}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </li>

                            </ul>
                          </div>
                        </div>
                      </Col>
                    )}

                    {isMobile ? (
                      <Col xs={12} className="d-none">
                        <div className="rcs_search_bar mobileSearchBox">
                          <Form
                            onSubmit={(e) => {
                              e.preventDefault();
                              history.push("/search/" + search_text);
                              window.scrollTo(0, 0);

                            }}
                          >
                            <svg
                              onClick={(e) => {
                                history.push("/search/" + search_text);
                                setSearch_text("");

                              }}
                              width="16"
                              height="16"
                              style={{ opacity: "0.3" }}
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M19.7112 18.3373L15.2347 13.8554C16.3899 12.3855 17.0878 10.5542 17.0878 8.55422C17.0878 3.83133 13.2611 0 8.54392 0C3.82671 0 0 3.83133 0 8.55422C0 13.2771 3.82671 17.1084 8.54392 17.1084C10.5656 17.1084 12.4188 16.4096 13.8628 15.2289L18.3393 19.7108C18.5319 19.9036 18.7726 20 19.0132 20C19.2539 20 19.4946 19.9036 19.7112 19.7108C20.0963 19.3253 20.0963 18.7229 19.7112 18.3373ZM1.92539 8.55422C1.92539 4.89157 4.88568 1.92771 8.54392 1.92771C12.2022 1.92771 15.1625 4.89157 15.1625 8.55422C15.1625 12.2169 12.2022 15.1807 8.54392 15.1807C4.88568 15.1807 1.92539 12.2169 1.92539 8.55422Z"
                                fill="var(--primary)"
                              ></path>
                            </svg>
                            <Form.Control
                              type="text"
                              placeholder="Search for.."
                              value={search_text}
                              onChange={(e) => setSearch_text(e.target.value)}
                            />
                            {/* <AiOutlineClose
                          onClick={() => setSearch_show(!search_show)}
                        /> */}
                          </Form>
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                </div>

                <>
                  <div className={HeaderStyle.showcase_bottom_header}>
                    {/* Menu Section */}
                    <div className="rcs_menu menu_list_main">
                      <Container fluid className="rcs_custome_container1">
                        <Row>
                          <nav id="rcs_menu_header_top">
                            <ul className="rcs_header_menu">
                              {menudata?.map((value, index) => (
                                <li
                                  className={
                                    "rcs_top_header_menu " +
                                    HeaderStyle.showcase_top_header_menu
                                  }
                                  onMouseEnter={() => {
                                    setHover(1);
                                    setSubmenu(value);
                                  }}
                                  onMouseLeave={() => setHover(0)}
                                  onClick={() => { setSearch_text('') }}
                                >
                                  <h6 className="1st">
                                    <NavLink to={value?.slug}>
                                      {value?.name}
                                    </NavLink>
                                  </h6>
                                  {value?.design == 5 ? (
                                    <ul
                                      className="rcs_top_header_menu_dropdown"
                                      onMouseEnter={() => setHover(1)}
                                      onMouseLeave={() => setHover(0)}
                                    >
                                      {submenu?.submenu?.map((val) => (
                                        <li className="dir rcs_top_header_menu1" onClick={() => { setSearch_text('') }}>
                                          <span>
                                            <NavLink to={val?.slug}>
                                              {val.name}
                                            </NavLink>
                                          </span>
                                        </li>
                                      ))}
                                    </ul>
                                  ) : (
                                    ""
                                  )}
                                </li>
                              ))}
                            </ul>
                          </nav>
                        </Row>
                      </Container>
                    </div>
                  </div>
                  {/*mega menu */}
                  <div className="menu_item_main">
                    {submenu?.design != 5 ? (
                      <div
                        onMouseEnter={() => setHover(1)}
                        onMouseLeave={() => setHover(0)}
                        onClick={()=>{setSearch_text('')}}
                        className={
                          hover == "1" && submenu?.submenu?.length
                            ? "rcs_top_header_menu_dropdown mega_menu_content_main visible bw-" +
                            submenu?.name?.replaceAll(" ", "-")
                            : "rcs_top_header_menu_dropdown mega_menu_content_main invisible"
                        }
                      >
                        <div className="rcs_megaMenu d-block">
                          <div className="rcs_megaMenu_inner_top">
                            <div className="rcs_megaMenu_inner">
                              <Container fluid className="p-0">
                                <Row className="w-100 m-auto  justify-content-center">
                                  {submenu?.submenu?.map((val, index) => (
                                    <>
                                      <Col
                                        lg={val?.col}
                                        xl={val?.col}
                                        className="pl-0"
                                      >
                                        {val?.submenu?.map((val1) =>
                                          val1?.design == "1" ? (
                                            <div
                                              className={
                                                "rcs_diamonds_content mj_daimond_d_font bw-" +
                                                val1?.name?.replaceAll(" ", "-")
                                              }
                                            >
                                              <div
                                                className={
                                                  "mega-list-cat " +
                                                  HeaderStyle.megaListCat
                                                }
                                              >
                                                <h2 className="title14 font-bold text-uppercase mtb">
                                                  {val1?.name}
                                                </h2>
                                                <ul>
                                                  {val1?.submenu?.map(
                                                    (val2) => (
                                                      <li>
                                                        {val2?.design == 4 ? (
                                                          <Link
                                                            to="#"
                                                            onClick={() =>
                                                              window.open(
                                                                img_url +
                                                                val2?.slug,
                                                                "_target"
                                                              )
                                                            }
                                                          >
                                                            {val2?.img_url
                                                              ?.length ? (
                                                              <img
                                                                src={
                                                                  val2?.img_url
                                                                }
                                                                className="img-size"
                                                                alt={
                                                                  val2?.alt_tag
                                                                }
                                                              />
                                                            ) : (
                                                              ""
                                                            )}
                                                            {val2?.name}
                                                          </Link>
                                                        ) : (
                                                          <Link to={val2?.slug}>
                                                            {val2?.img_url
                                                              ?.length ? (
                                                              <img
                                                                src={
                                                                  val2?.img_url
                                                                }
                                                                className="img-size"
                                                                alt={
                                                                  val2?.alt_tag
                                                                }
                                                              />
                                                            ) : (
                                                              ""
                                                            )}
                                                            {val2?.name}
                                                          </Link>
                                                        )}
                                                      </li>
                                                    )
                                                  )}
                                                </ul>
                                              </div>
                                            </div>
                                          ) : val1?.design == "2" ? (
                                            <div
                                              className={
                                                "rcs_diamonds_content dfL-border_rel bw-" +
                                                val1?.name?.replaceAll(" ", "-")
                                              }
                                            >
                                              <h2> {val1?.name} </h2>
                                              <div className="m-auto w-100 row">
                                                {val1?.submenu?.map((val2) => (
                                                  <div className="cust_padd_diamonds_shape col-lg-6">
                                                    <div className="rcs_diamonds_content_inner">
                                                      <Link to={val2?.slug}>
                                                        {val2?.img_url
                                                          ?.length ? (
                                                          <img
                                                            src={val2?.img_url}
                                                            alt={val2?.alt_tag}
                                                          />
                                                        ) : (
                                                          ""
                                                        )}
                                                        <p>{val2?.name}</p>
                                                      </Link>
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          ) : val1?.design == "3" ? (
                                            <div className="rcs_diamonds_content">
                                              <Link to={val1?.slug}>
                                                {val1?.img_url?.length ? (
                                                  <img
                                                    src={val1?.img_url}
                                                    alt={val1?.alt_tag}
                                                    className="img-fluid dfl_ddiamond_img"
                                                    style={{
                                                      height: "100%",
                                                      objectFit: "cover",
                                                    }}
                                                  />
                                                ) : (
                                                  ""
                                                )}
                                              </Link>
                                            </div>
                                          ) : (
                                            ""
                                          )
                                        )}
                                        {index < 2 ? (
                                          <div className="dfl_menu_border"></div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </>
                                  ))}
                                </Row>
                              </Container>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              </Container>
            </div>
            {/* Header Section */}

            {hover == "1" && submenu?.submenu?.length ? (
              <div className="hover_overlayer"></div>
            ) : (
              ""
            )}
          </div>
        </div>
        {/* Mobile Menu Section */}
        <div className="rcs_menu_mobile d-none">
          <Container>
            <Row>
              <Drawer
                anchor="left"
                open={left}
                onClose={() => toggleDrawer(false)}
              >
                <div
                  role="presentation"
                // onKeyDown={() => toggleDrawer(false)}
                >
                  <div
                    className={
                      show === true ? "mobile-menu" : "mobile-menu nav-open"
                    }
                  >

                    <div className="inner-mobile-menu">
                      <div className="rcs_search_bar mobileSearchBox px-2 mt-2">
                        <Form
                          onSubmit={(e) => {
                            e.preventDefault();
                            history.push("/search/" + search_text);
                            window.scrollTo(0, 0);
                            setSearch_text("");

                            toggleDrawer(false);
                          }}
                        >
                          {/* <SearchIcon
                          onClick={(e) => {
                            history.push("/search/" + search_text);
                            setSearch_text("");
                            
                          }}
                        /> */}
                          <svg
                            onClick={(e) => {
                              setSearch_text("");
                              history.push("/search/" + search_text);
                            }}
                            width="16"
                            height="16"
                            style={{ opacity: "0.3" }}
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M19.7112 18.3373L15.2347 13.8554C16.3899 12.3855 17.0878 10.5542 17.0878 8.55422C17.0878 3.83133 13.2611 0 8.54392 0C3.82671 0 0 3.83133 0 8.55422C0 13.2771 3.82671 17.1084 8.54392 17.1084C10.5656 17.1084 12.4188 16.4096 13.8628 15.2289L18.3393 19.7108C18.5319 19.9036 18.7726 20 19.0132 20C19.2539 20 19.4946 19.9036 19.7112 19.7108C20.0963 19.3253 20.0963 18.7229 19.7112 18.3373ZM1.92539 8.55422C1.92539 4.89157 4.88568 1.92771 8.54392 1.92771C12.2022 1.92771 15.1625 4.89157 15.1625 8.55422C15.1625 12.2169 12.2022 15.1807 8.54392 15.1807C4.88568 15.1807 1.92539 12.2169 1.92539 8.55422Z"
                              fill="var(--primary)"
                            ></path>
                          </svg>
                          <Form.Control
                            type="text"
                            placeholder="Search for.."
                            value={search_text}
                            onChange={(e) => setSearch_text(e.target.value)}
                          />
                          {/* <AiOutlineClose
                          onClick={() => setSearch_show(!search_show)}
                        /> */}
                        </Form>
                      </div>

                      <Accordion defaultActiveKey="0">
                        {/* <Accordion.Item eventKey="0">
                                <Accordion.Header><Link to="#"><span className='auth'><img src={User} alt="" /></span> LOGIN/SIGNUP</Link></Accordion.Header>
                            </Accordion.Item> */}
                        {menudata?.map((val, index) => (
                          <>
                            <Accordion.Item eventKey={index}>
                              <Accordion.Header
                                className={`${val.name === "Custom Design" ||
                                  val.name === "Watches"
                                  ? "no_button"
                                  : ""
                                  }`}
                              >
                                <Link
                                  to={val.slug}
                                  onClick={() => toggleDrawer(false)}
                                >
                                  {val.name}
                                </Link>
                              </Accordion.Header>
                              <Accordion.Body>
                                {val?.submenu?.map((val1) =>
                                  val1?.submenu?.map((val2) =>
                                    val2?.design == 3 ? (
                                      <img
                                        className="w-100 mt-2"
                                        onClick={() => history.push(val2?.slug)}
                                        src={val2?.img_url}
                                        alt={val2?.alt_tag}
                                      />
                                    ) : (
                                      <>
                                        <h2 className="title">{val2?.name}</h2>
                                        <ul
                                          className={
                                            val2?.design == 2
                                              ? "two-col-list"
                                              : "single-col-list"
                                          }
                                        >
                                          {val2?.submenu?.map((val3) => (
                                            <li>
                                              <Link
                                                onClick={() =>
                                                  toggleDrawer(false)
                                                }
                                                to={val3.slug}
                                              >
                                                {val3?.img_url ? (
                                                  <img
                                                    src={val3?.img_url}
                                                    alt={val3?.alt_tag}
                                                  />
                                                ) : (
                                                  ""
                                                )}
                                                {val3?.name}
                                              </Link>
                                            </li>
                                          ))}
                                        </ul>
                                      </>
                                    )
                                  )
                                )}
                              </Accordion.Body>
                            </Accordion.Item>
                          </>
                        ))}

                        <Accordion.Item className="d-block d-sm-none">
                          <Accordion.Header
                            className={`no_button`}
                          >
                            <Link
                              to={
                                user?.isLogin
                                  ? "/account/wishlist"
                                  : "/wishlist"
                              }
                              onClick={() => toggleDrawer(false)}
                              className="d-flex align-items-center justify-content-between"
                            >
                              <span> Wishlist </span>
                              {wishlistlength > 0 && <span className="badge badge-btn"> {wishlistlength} </span>}
                            </Link>
                          </Accordion.Header>
                        </Accordion.Item>


                        <Accordion.Item eventKey="7" className="contactDetail">
                          <Accordion.Header>Contact us</Accordion.Header>
                          <div className="contact_detail">
                            <ul>
                              {/* <li>
                                <a
                                  onClick={() => setShow(false)}
                                  target="_blank"
                                href="https://api.whatsapp.com/send?phone=+6469929024 &amp;text=Hi Arman Jwelers ! I have a few queries. Could you please help me out?"

                                >
                                  <span>
                                    <BsFillChatFill />
                                  </span>
                                  Chat
                                </a>
                              </li> */}
                              <li>
                                <a
                                  onClick={() => {
                                    setShow(false);
                                    window.location.href = contact_number.link;
                                  }}
                                  href="#"
                                >
                                  <span>
                                    <BsFillTelephoneFill />
                                  </span>
                                  Call
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={(e) => {
                                    setShow(false);
                                    window.location.href = Email_details.link;
                                  }}
                                >
                                  <span>
                                    <IoMdMail />
                                  </span>
                                  Email
                                </a>
                              </li>
                              <li onClick={() => toggleDrawer(false)}>
                                <Link
                                  onClick={() => {
                                    setShow(false);
                                    toggleDrawer(false)
                                  }
                                  }
                                  to="/contact"
                                >
                                  <span>
                                    <IoMdContact />
                                  </span>
                                  Contact
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </Drawer>
            </Row>
          </Container>
        </div>
        {/* Mobile Menu Section */}
      </div>
    </>
  );
};
export default MegaMenu;
